import React, { useState } from "react";
import "../Css/Products.css";
import { useLocation } from "react-router-dom";
import ProductJson from "../Components/Data/Product";
import BannerComp from "./BannerComp";
import { Image } from "antd";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import certifiedBanner from "../Assets/product/Certified/certified_banner.png";
import { MetaTags } from "react-meta-tags";

const Products = () => {
  const serach = useLocation();
  const pathN = serach.pathname;
  // console.log("pathN",pathN)
  const productD = ProductJson.find((v) => v.slug == pathN);
  const [visible, setVisible] = useState({ image: "", isVisible: false });
// console.log("productD",productD)
  return (
    <>
      <MetaTags>
        <title>{productD?.metaTitle}</title>
        <meta title={productD?.metaTitle} />
        <meta name="description" content={productD?.metaDescription} />
        <meta name="keywords" content="Melee Diamonds For Jewellery,Best Diamonds Collection ,Diamond Wholesaler ,Fancy Color Diamonds ,Melee Diamonds,Certified Melee Diamonds,Fancy Diamonds With Different Shape,Black Diamonds ,Certified Diamonds,Customized Diamonds,Certified Fancy diamond,Natural Diamonds ,Calibrated Diamonds ,Best Ntural Diamond Supplier ,Best Natural Diamond Exhibition ,Best Natural Diamond Dealer,Reasonable Diamond In USA,Fast Delivery Diamonds ,High Quality Diamond In USA,Best Diamond Company In USA,Diamond For Jewelry In USA,cheapest Rate Diamond In USA,Natural Melee Diamond In USA,Reasonable Diamond In UK,Fast Delivery ,High Quality Diamond In UK,Best Diamond Company In UK,Diamond For Jewellery In UK,cheapest Rate Diamond In UK,Melee Diamond In UK,Reasonable Diamond In Canada,Fast Delivery ,High Quality Diamond In Canada,Best Diamond Company In Canada,Diamond For Jewellery In Canada,cheapest Rate Diamond In Canada,Melee Diamond In Canada,Reasonable Diamond In Australia,Fast Delivery ,High Quality Diamond In Australia,Best Diamond Company In Australia,Diamond For Jewellery In Australia,cheapest Rate Diamond In Australia,Melee Diamond In Australia,Reasonable Diamante In Mexico,Fast Delivery ,High Quality Diamante In Mexico,Best Diamante Company In Mexico,Diamante For joyas In Mexico,cheapest Rate Diamante In Mexico,Melee Diamante In Mexico,Reasonable Diamante In Columbia,Fast Delivery ,High Quality Diamante In Columbia,Best Diamante Company In Columbia,Diamante For joyas In Columbia,cheapest Rate Diamante In Columbia,Melee Diamante In Columbia,Reasonable Diamante In Italy,Fast Delivery ,High Quality Diamante In Italy,Best Diamante Company In Italy,Diamante For gioielli In Italy,cheapest Rate Diamante In Italy,Melee Diamante In Italy,Reasonable Diamant In France,Fast Delivery ,High Quality Diamant In France,Best Diamant Company In France,Diamant For bijoux In France,cheapest Rate Diamant In France,Melee Diamant In France,Reasonable Diamant In Germany,Fast Delivery ,High Quality Diamant In Germany,Best Diamant Company In Germany,Diamant For Schmuck In Germany,cheapest Rate Diamant In Germany,Melee Diamant In Germany,Reasonable diamant In Denmark,Fast Delivery ,High Quality diamant In Denmark,Best diamant Company In Denmark,diamant For Schmuck In Denmark,cheapest Rate diamant In Denmark,Melee diamant In Denmark,Reasonable diamant In Sweden,Fast Delivery ,High Quality diamant In Sweden,Best diamant Company In Sweden,diamant For smycke In Sweden,cheapest Rate diamant In Sweden,Melee diamant In Sweden,Reasonable Diamond In South Africa,Fast Delivery ,High Quality Diamond In South Africa,Best Diamond Company In South Africa,Diamond For Jewellery In South Africa,cheapest Rate Diamond In South Africa,Melee Diamond In South Africa,Reasonable Diamond In Hong Kong,Fast Delivery ,High Quality Diamond In Hong Kong,Best Diamond Company In Hong Kong,Diamond For Jewellery In Hong Kong,cheapest Rate Diamond In Hong Kong,Melee Diamond In Hong Kong,Reasonable Diamond In Dubai,Fast Delivery ,High Quality Diamond In Dubai,Best Diamond Company In Dubai,Diamond For Jewellery In Dubai,cheapest Rate Diamond In Dubai,Melee Diamond In Dubai,Reasonable Diamond In Malaysia,Fast Delivery ,High Quality Diamond In Malaysia,Best Diamond Company In Malaysia,Diamond For Jewellery In Malaysia,cheapest Rate Diamond In Malaysia,Melee Diamond In Malaysia,Reasonable Diamond In Singapore,Fast Delivery ,High Quality Diamond In Singapore,Best Diamond Company In Singapore,Diamond For Jewellery In Singapore,cheapest Rate Diamond In Singapore,Melee Diamond In Singapore,Reasonable Diamond In Thailand,Fast Delivery ,High Quality Diamond In Thailand,Best Diamond Company In Thailand,Diamond For Jewellery In Thailand,cheapest Rate Diamond In Thailand,Melee Diamond In Thailand,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia" />
        <link rel="canonical" href={productD?.metaCanonical} />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content={productD?.metaTitle} />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sejalexports.in/" />
        <meta property="og:description" content={productD?.metaDescription} />
        <meta property="og:image" content="https://sejalexports.in/static/media/logo.3d243a21eddc9f360630.png" />
      </MetaTags>
      <BannerComp
        title={productD.name}
        breadcrumb={[
          {
            title: "Home",
            href: "/",
          },
          {
            title: "Product",
          },
          {
            title: productD.name,
          },
        ]}
        image={
          productD.slug == "/certified-diamonds"
            ? certifiedBanner
            : productD.banner
        }
      />
      <section className="sectionDiv p-0 productContent">
        <div className="container">
          {productD?.htmlContent ? (
            <div dangerouslySetInnerHTML={{ __html: productD.htmlContent }} />
          ) : (
            <>
              <p>{productD?.decOne}</p>
              <p>{productD?.decSecond}</p>
              <p>{productD?.descThird}</p>
              <p>{productD?.descFourth}</p>
            </>
          )}
        </div>
      </section>

      {productD?.gallery && (
        <>
          <section className="sectionDiv">
            <div className="container">
              <div className="row">
                {productD?.gallery.map((val, index) => (
                  <div className= {productD.name === "Certified Diamonds" ? "col-md-3 mb-4" :"col-md-4 mb-4"} key={index}>
                    <div
                      className="galleryImage"
                      onClick={() =>
                        setVisible({ image: val, isVisible: true })
                      }
                    >
                      <img
                        alt="Certified Diamonds"
                        style={{
                          width: "100%",
                          minHeight:productD.name === "Certified Diamonds" && 300,
                          maxHeight: "460px",
                          height: "100%",
                          objectFit: "cover",
                          objectPosition: "bottom",
                        }}
                        src={val}
                      />
                      <MdOutlineRemoveRedEye />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <Image
            width={200}
            style={{ display: "none" }}
            src={`${visible.image}?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200`}
            preview={{
              visible: visible.isVisible,
              src: visible.image,
              onVisibleChange: (value) => {
                setVisible((prev) => ({ image: "", isVisible: false }));
              },
            }}
          />
        </>
      )}
    </>
  );
};

export default Products;
